module.exports = __webpack_public_path__ + "static/36-0dc6bf371cb1dc44da3f5002acef5fe8.jpg";